export default {
  NEW: 1,
  NEARLY_NEW: 2
}
